module.exports = __webpack_public_path__ + "img/level1.2fc6700a.png";